import ClickAndCollectResults from './ClickAndCollectResults';

export default ClickAndCollectResults;
